module.exports = __webpack_public_path__ + "static/media/01-Lima.a378729f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/01-Lima.png
// module id = 1034
// module chunks = 0